import { MenuItem, SxProps, TextField } from "@mui/material";
import { useContext } from "react";
import { EntityAuthOption } from "src/services/link/queries/NetTypes";

import Context from "../../context";

// ----------------------------------------------------------------------

const sxItem: SxProps = {
	mx: 1,
	my: 0.5,
	borderRadius: 0.75,
	typography: "body2"
};

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
	values: EntityAuthOption[];
	label: string;
};

export const LoginSelector = ({ values, onChangeSelect, selectedValue, label }: Props) => {
	const { entity } = useContext(Context);

	return (
		<TextField
			fullWidth
			select
			disabled={entity?.maintenance}
			label={label}
			value={selectedValue}
			onChange={(e: any) => onChangeSelect(e.target.value)}
		>
			{values.map((option, index) => (
				<MenuItem key={index} value={option.value} sx={sxItem}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

export default LoginSelector;
